export const zh = [
  [
    {
      name: '产品',
      items: [
        {
          name: '思码逸 DevInsight',
          url: 'https://www.merico.cn/devinsight-3-0',
        },
        {
          name: '思码逸 DevChat',
          url: 'https://www.devchat.ai/',
        },
        {
          name: '解决方案',
          url: 'https://www.merico.cn/solutions',
        },
      ],
    },
    {
      name: '下载资料',
      items: [
        {
          name: '资料下载中心',
          url: 'https://www.merico.cn/resources',
        },
        {
          name: '软件研发效能度量规范',
          url: 'https://www.merico.cn/standard-download',
        },
        {
          name: '研发效能 100 问',
          url: 'https://www.merico.cn/ask-for-100qv1',
        },
        {
          name: '研发效能红宝书',
          url: 'https://www.merico.cn/ask-for-pocketbook-1',
        },
      ],
    },
    {
      name: '客户案例',
      items: [
        {
          name: '贝壳',
          url: 'https://www.merico.cn/solutions/beke',
        },
        {
          name: '泰康集团',
          url: 'https://www.merico.cn/solutions/insurance-group',
        },
        {
          name: '戴尔EMC',
          url: 'https://www.merico.cn/solutions/dellvxrail',
        },
        {
          name: '妙盈科技',
          url: 'https://www.merico.cn/solutions/miotech',
        },
        {
          name: '某电商平台',
          url: 'https://www.merico.cn/solutions/ecommerce',
        },
      ],
    },
    {
      name: '提效学堂',
      items: [
        {
          name: '干货文章',
          url: 'https://www.merico.cn/blog',
        },
        {
          name: '提效视频',
          url: 'https://www.merico.cn/video',
        },
        {
          name: 'GQM 度量体系',
          url: 'https://www.merico.cn/blog/gqm',
        },
        {
          name: 'MARI指标体系和效能改进指南',
          url: 'https://www.openmari.dev/',
        },
      ],
    },
  ],
  [
    {
      name: '能力',
      items: [
        {
          name: '数据归集与治理',
          url: 'https://www.merico.cn/insight-data-hub',
        },
        {
          name: '深度代码分析',
          url: 'https://www.merico.cn/merico-eloc',
        },
        {
          name: '研发效能数据 BI',
          url: 'https://www.merico.cn/bi',
        },
        {
          name: '企业系统集成',
          url: 'https://www.merico.cn/embedded-analytics',
        },
      ],
    },
    {
      name: '开源贡献',
      items: [
        {
          name: 'Apache DevLake',
          url: 'https://devlake.apache.org/',
        },
      ],
    },
    {
      name: '帮助与支持',
      items: [
        {
          name: '快速开始',
          url: '/ee/dev/quick_start/overview',
        },
        {
          name: '常见问题',
          url: '/faq2022',
        },
      ],
    },
    {
      name: '关于我们',
      items: [
        {
          name: '公司介绍',
          url: 'https://www.merico.cn/about-us',
        },
      ],
    },
  ],
]

export const en = zh
